import { render, staticRenderFns } from "./DriversList.vue?vue&type=template&id=5bf8ef92&"
import script from "./DriversList.vue?vue&type=script&lang=js&"
export * from "./DriversList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DriversList.vue"
export default component.exports